<template>
  <div class="w-100 h-100 d-flex flex-column position-relative">

    <div class="row my-2">
      <div class="col">
        <div class="menu-tab-text menu-select-color">データ入稿</div>
      </div>
    </div>

    <div class="row p-2 position-relative" :class="{'feature-ui':this.$store.state.tutorial.isShowPreview && this.$store.state.tutorial.previewStep == 1}">
      <div class="row text-start m-0">
        <p class="m-0 p-0">デザイン（PNG）<img src="@/assets/acrypro/question-icon.svg" style="width:20px;height:20px;margin-left:-5px;margin-top:-5px;" class="cursor-pointer" @click="clickPngHelp()" /></p>
      </div>
      <label class="uploadlabel position-relative"
        ><input
          type="file"
          ref="design"
          accept=".png"
          @change="uploadDesign"
        />
        <div v-if="!isUploadDesign">
          <svg class="fill-color" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
          <path d="M22.4167 13.0002C22.4167 7.52565 17.9836 3.0835 12.5104 3.0835C7.02583 3.0835 2.58335 7.52663 2.58335 13.0002C2.58335 18.4737 7.02584 22.9168 12.5104 22.9168C17.9836 22.9168 22.4167 18.4747 22.4167 13.0002ZM21.3334 13.0002C21.3334 17.8805 17.3803 21.8335 12.5 21.8335C7.61971 21.8335 3.66669 17.8805 3.66669 13.0002C3.66669 8.11986 7.61971 4.16683 12.5 4.16683C17.3803 4.16683 21.3334 8.11985 21.3334 13.0002Z"/>
          <path d="M7.5 13.8332L17.5 13.8332L17.5 12.1665L7.5 12.1665L7.5 13.8332Z"/>
          <path d="M13.3334 18L13.3334 8L11.6667 8L11.6667 18L13.3334 18Z"/>
          </svg>
          <span class="fw-bold">アップロード</span>
        </div>
        <div v-else>
          <span class="text-main-color">{{this.getDesignFileName()}}</span>
        </div>
      </label>
    </div>

    <hr class="mt-1 mb-0">

    <div class="row my-1">
      <div class="col m-0">
        <div class="menu-tab-text menu-select-color m-0">個数・金額</div>
      </div>
    </div>



    <!-- 境界線 -->

    <p class="m-1 text-start" style="font-size: 15px;">金額</p>
    <p class="fw-bold m-1 text-end mb-0" style="">{{totalPrice}}円</p>
    <hr class="m-0">

    <p class="m-1 text-start" style="font-size: 15px;">( 1枚単価 <span class="status-error-color">{{discountText}}</span> )</p>
    <p class="fw-bold m-1 text-end mb-0" style="">{{price}}円</p>
    <hr class="m-0">

    <p class="m-1 text-start" style="font-size: 15px;">数量</p>
    <div class="m-1 mb-2 text-end d-flex justify-content-end form" style="">
      <input type="number" min="1" max="1000" v-model="acrylNum" @blur="numBlur" class="forminput text-end no-spin pe-2" />
    </div>
    <hr class="m-0">

    <div class="mt-auto w-100 my-3 position-relative" :class="{'disable-ui':!(isUploadDesign) && !this.$store.state.tutorial.isShowPreview}">
      <div>
        <button @click="clickCart" class="acry-btn-cartin btn-size my-1" >カートに入れる</button>
      </div>
    </div>

    <TutorialModal
      :visible="$store.state.tutorial.isShowPreview && $store.state.tutorial.previewStep == 1"
      title="デザイン入稿（PNG）"
      arrowTop="40px"
      style="height:242px; top:120px; right: 350px;"
      @close="tutorialNextStep()">
      <p class="text-start">作成されたPNGデータをアップロードします</p>
      <p class="text-start m-0">アップロードするとキャンバスにプレビュー表示されます。</p>
      <p class="text-start">プレビューでズレが発生する場合サイズが間違っている可能性がありますのでデータを確認ください。</p>
    </TutorialModal>
  </div>
</template>

<script>
import {
  ProductId,
  CenterViewState,
  RightViewState,
  GetAcryProductPrice,
  GetAcryProductSizeText,
} from "@/js/Const.js";
import { CreateFrameCutlineImage, DiscountRatio, CombineSVGFrame, TrimmingDesignImageFile, ConvertSvgToPng } from "@/js/CommonFunc.js";
import { ProductData } from "@/js/ProductData.js";
import VueCookies from "vue-cookies";
import { Big } from 'big.js';
import { Analytics } from "@/js/Analytics.js";
import { FileKit } from "@/js/FileKit.js";
import TutorialModal from "@/components/acyrpro/modal/TutorialModal.vue";

export default {
  name: "RightMenuPrintPreview_Ap",
  props: {},
  data: function () {
    return {
      designFileName:"デザインデータ",
      cutlineFileName:"カットラインデータ",
      acrylNum: 10,
      price: 0,       // 割引後の1枚あたりの金額
      discountText: "",
      totalPrice: 0,  // 合計金額（税別）
      selectProductData: null,

      designFileKit: null,
      cutlineFileKit: null,
      frameCutlineImageURL: null, // プレビュー画像合成用
    };
  },
  watch: {
  },
  computed: {
    isUploadDesign() {
      return this.$store.state.acryPrint.designData != null;
    },
    isUploadCutline() {
      return this.$store.state.acryPrint.cutlineData != null;
    },
  },
  async created() {
    this.$store.commit("setIsFirstTutorial", false);

    // 販売中のプロダクト情報を取得
    // this.$store.commit("showRightMenu");
    this.$store.commit("showLoading");
    await this.$store.state.saleProductManager.update().catch((e) => {
      this.$handleError("032", e, { hideLoading: true });
      return;
    });

    if (
      this.$store.state.saleProductManager.getProduct(
        this.$store.state.acryPrint.selectProductId
      ) == null
    ) {
      this.$store.commit("hideLoading");
      this.$store.commit("showMessage", "現在販売されていない商品です");
      this.$store.commit("setCenterViewState", CenterViewState.Upload);
      return;
    }

    this.selectProductData = this.$store.state.saleProductManager.getProduct(
      this.$store.state.acryPrint.selectProductId
    );

    this.updatePriceText();

    this.$store.commit("hideLoading");

    // if( this.$store.state.isShareCodeDraft ){
    //   // シェアコード入稿
    //   // SVGチュートリアルをすでに見ている場合は無視
    //   let isTutorial = VueCookies.get("t_sp") || VueCookies.get("t_p");
    //   if( !isTutorial ){
    //     this.$store.commit("setIsFirstTutorial", true);

    //     VueCookies.set("t_sp", true, '1y');

    //     // チュートリアル開始
    //     this.$store.commit("showPreviewTutorial", 3);
    //   }
    // }else{
      // SVG入稿
      let isTutorial = VueCookies.get("t_p");
      if( !isTutorial ){
        this.$store.commit("setIsFirstTutorial", true);

        VueCookies.set("t_p", true, '1y');

        // チュートリアル開始
        this.$store.commit("showPreviewTutorial");
      }
    //}

  },
  components: { TutorialModal },
  methods: {
    numBlur(){
      if( isNaN(this.acrylNum) ) this.acrylNum = 1;
      if( this.acrylNum < 1 ) this.acrylNum = 1;
      if( this.acrylNum > 1000 ) this.acrylNum = 1000;
      this.updatePriceText();
    },
    getDesignFileName(){
      return this.designFileName;
    },
    getCutlineFileName(){
      return this.cutlineFileName;
    },
    async uploadDesign() {
      let file = this.$refs.design.files[0];
      this.designFileName = file.name;

      // 商品に合わせてトリミング
      file = await TrimmingDesignImageFile(file, this.selectProductData.productId);
      this.designFileKit = new FileKit(file);
      this.$store.commit('acryPrint/set', { key: 'designData', value: this.designFileKit })

      // プレビュー用に画像を設定
      this.$store.commit('designPreview/set', { key: 'designImageURL', value: this.designFileKit.fileURL })

      // AcryPrintはカットラインがないのでからのSVGを自動設定
      // 処理の問題でデザインを上げたついでにカットラインも
      if( !this.isUploadCutline ){
        this.uploadCutline();
      }
    },
    async uploadCutline() {
      let svgFileName = '';
      switch(this.$store.state.acryPrint.selectProductId){
        case ProductId.ACRY_PRINT_S:
          svgFileName = 'empty_cutline_s.svg';
          break;
        case ProductId.ACRY_PRINT_M:
          svgFileName = 'empty_cutline_m.svg';
          break;
        case ProductId.ACRY_PRINT_L:
          svgFileName = 'empty_cutline_l.svg';
          break;
      }

      const response = await fetch('/acryprint/'+svgFileName);
      const fileBlob = await response.blob();
      let file = new File([fileBlob], 'empty_cutline_s.svg', { type: 'image/svg+xml' });

      // フレームパスを合成
      file = await CombineSVGFrame(file, this.selectProductData.productId);
      const fileKit = new FileKit(file);
      this.cutlineFileKit = fileKit;
      this.$store.commit('acryPrint/set', { key: 'cutlineData', value: fileKit })

      // SVGをPNGに変換
      // let fileUrl = await ConvertSvgToPng(fileKit.fileURL, this.selectProductData.productId);

      // SVGをPNGに変換
      let fileUrl = await ConvertSvgToPng(fileKit.fileURL, this.selectProductData.productId);
      this.$store.commit('designPreview/set', { key: 'cutlineImagePngURL', value: fileUrl });

      // // 線状のもの
      const blob = await CreateFrameCutlineImage(fileUrl);
      this.frameCutlineImageURL = URL.createObjectURL(blob)
    },
    updatePriceText(){
      // 数量変更される
      if( this.acrylNum == 0 ){
        this.totalPrice = this.price = 0;
        this.discountText = "";
      }else{
        let productPrice = GetAcryProductPrice(this.selectProductData.productId);
        let productTotal = parseInt(this.acrylNum) + parseInt(this.$store.state.cartManager.getCartProductQuantity(this.selectProductData.productId));
        let ratio = DiscountRatio(productTotal);

        if( ratio == 0 ){
          this.discountText = "";
        }else{
          this.discountText = ratio + "%割引適応";
        }

        // 丸め誤差が出ないようにライブラリを使用して計算
        let priceBaseTotal = new Big(this.acrylNum * productPrice.priceBase); // 税抜き価格の合計
        let priceRatio = new Big(100-ratio).div(100);
        let totalPrice = priceBaseTotal.times(priceRatio);
        this.totalPrice = Math.floor(totalPrice.toNumber());
        this.price = Math.floor(this.totalPrice / this.acrylNum);
      }
    },

    async clickCart() {
      if (!(this.isUploadDesign )) {
        this.$store.commit("showMessage", "入稿されていないデータがあります");
        return;
      }

      if (this.acrylNum < 1) {
        this.$store.commit("showMessage", "1枚以上にしてください");
        return;
      }

      // プログレスバーを表示
      this.$store.commit("showProgress");
      this.$store.commit("setProgressMessages", [
        "デザインデータを作成中…",
        "しばらくお待ちください",
      ]);

      // プロダクトタイプが再編集になっている場合はカートの中のものを削除
      // if (this.$store.state.currentProduct && this.$store.state.currentProduct.cartId != "") {
      //   await this.$store.state.cartManager
      //     .delete(this.$store.state.currentProduct.cartId)
      //     .catch((e) => {
      //       this.$store.commit("hideProgress");
      //       this.$common.log(e);
      //       this.$store.commit("showMessage", "エラーが発生しました");
      //       return;
      //     });
      // }

      await this.createProduct();
      this.$store.commit("setProgress", 5);

      // await this.$store.state.draftManager
      //   .registDesign(this.$store.state.currentProduct, false, this.$store)
      //   .catch((e) => {
      //     this.$store.commit("hideProgress");
      //     this.$common.log(e);
      //     this.$store.commit("showMessage", "エラーが発生しました");
      //     return;
      //   });
      this.$store.commit("setProgress", 15);

      let self = this;
      await this.$store.state.cartManager.addCartAcryPrint(this.$store.state.currentProduct, function(progress){
        self.$store.commit("setProgress", 15 + (85 / 100 * progress));
      })
        .catch((e) => {
          this.$handleError("033", e, { hideProgress: true });
          return;
        });

      // 割引後の単価を計算
      const productPrice = GetAcryProductPrice(this.selectProductData.productId);
      const totalQuantity = parseInt(this.$store.state.cartManager.getCartProductQuantity(this.selectProductData.productId));
      const ratio = DiscountRatio(totalQuantity);
      // 丸め誤差が出ないようにライブラリを使用して計算
      const priceBase = new Big(productPrice.priceBase);
      const priceRatio = new Big(100-ratio).div(100);
      const discountPrice = priceBase.times(priceRatio);

      const productSizeTxt = GetAcryProductSizeText(this.selectProductData.productId);
      Analytics.addToCartAcryPrint(this.$store.state.currentProduct.productId, this.$store.state.currentProduct.productName, this.$store.state.currentProduct.quantity, discountPrice.toNumber(), productSizeTxt );

      this.$store.commit("hideProgress");
      this.$store.commit("showMessage", "カートに追加しました");

      // 表示を戻す
      this.$store.commit("setCenterViewState", CenterViewState.AcryPrint);
      this.$store.commit("setRightViewState", RightViewState.Cart);
    },

    async createProduct() {
      let p = new ProductData(
        this.selectProductData,
        this.selectProductData.productData["product_class_list2"][0]
      );

      p.quantity = this.acrylNum;
      p.setPrintInfo("front");
      p.tagTemplateName = "";
      p.isShareCodeDraft = this.$store.state.isShareCodeDraft;

      this.$store.commit("addProduct", p);
      this.$store.commit("selectCanvasData", p.canvasDatas[0]);

      await this.$store.state.currentCanvasData.setBaseImage(
        this.$store.state.acryPrint.designData.file,
        this.$store.state.acryPrint.designData.fileURL,
        //(this.$store.state.isShareCodeDraft)?this.$store.state.scCutlineImageFile:this.$store.state.cutlineImageFile,
        this.$store.state.acryPrint.cutlineData.file,
        this.frameCutlineImageURL
      );
    },

    tutorialNextStep(){
      if( this.$store.state.tutorial.isFirst ){
        // 初回は強制で全て表示
        if(this.$store.state.tutorial.previewStep == 3){
          this.$store.commit("hidePreviewTutorial");
          this.$store.commit("setIsFirstTutorial", false);
        }else{
          this.$store.commit("previewTutorialNextStep");
        }
      }else{
        // 2回目以降は一部分のみ表示
          this.$store.commit("hidePreviewTutorial");
      }
    },
    clickPngHelp(){
      this.$store.commit("showPreviewTutorial", 1);
    },
    clickSvgHelp(){
      this.$store.commit("showPreviewTutorial", 2);
    },

  },
};
</script>

<style scoped lang="scss">
.uploadlabel {
  margin: 8px;
  padding: 8px;
  cursor: pointer;
  font-size: 15px;
  width: 290px;
  height: 40px;
  color: $primary-main-color;
  border: 2px solid $primary-main-color;
  border-radius: 100px;
  background: $background-white-color;
}

.fill-color {
  fill: $primary-main-color;
  position: absolute;
  left: 51px;
  top: 6px;
}

input[type="file"] {
  display: none;
}

.btn-size{
  width: 100%;
  height: 40px;
  font-weight: bold;
}
.form{
  height: 48px;

}

.forminput {
  width: 100%;
  border: 1px solid $status-success-color;
}

.disable-ui {
  opacity: 0.5;
}

.feature-ui{
  z-index: 3;
  pointer-events: none;
  background: white;
}
</style>
